import React from 'react';
// import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
//import debounce from 'lodash.debounce'

import facebook from '../../../assets/front/img/footer/facebook.png';
import twitter from '../../../assets/front/img/footer/twitter.png';
import youtube from '../../../assets/front/img/footer/youtube.png';
import instagram from '../../../assets/front/img/footer/instagram.png';
import blog from '../../../assets/front/img/footer/blog.png';
import kakaostory from '../../../assets/front/img/footer/kakaostory.png';
import happybean from '../../../assets/front/img/footer/happybean.png';

import aside1 from '../../../assets/front/img/footer/aside-1.png';
import aside2 from '../../../assets/front/img/footer/aside-2.png';
import aside3 from '../../../assets/front/img/footer/aside-3.png';

class Footer extends React.Component {

    constructor(props) {
        super(props);
        this.state = ({
            asideOffset: ((window.innerWidth - 1200) / 2) - 30,
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.listenToResize);
        //window.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.listenToResize);
        //window.removeEventListener('scroll', this.listenToScroll)
    }

    listenToResize = event => {
        const width = window.innerWidth;
        //console.log(width);
        if (width > 1280) {
            const asideOffset = ((width - 1200) / 2) - 30;
            this.setState(prevState => {
                return {
                    asideOffset,
                };
            });
        }
    }

    listenToScroll = event => {
        console.log(event);
    }

    render() {
        return (
            <div>
				<footer className="g-font-size-12" style={{ backgroundColor: "#F9F9F9", color: "#BDBDBD" }}>

					<div className="container">
						<div className="g-hidden-sm-down">
							<div className="row g-py-35">
								<div className="col-lg-7 col-md-12 ">
									<p className="mb-0">
										<span className="g-pr-10 font-weight-bold">(사)동물권행동 카라</span>
										<span className="g-pr-10">서울시 마포구 잔다리로 122 (우) 03998</span>
										<span className="">대표: 전진경</span>
									</p>
									<p className="mb-0">
										<span className="g-pr-10">MAIL: <a href="mailto:info@ekara.org" style={{ color: "#BDBDBD" }}>info@ekara.org</a></span>
										<span className="g-pr-10">TEL: <a href="tel:02-3482-0999" style={{ color: "#BDBDBD" }}> 02 - 3482 - 0999</a></span>
										<span className="g-pr-10">FAX : <a href="tel:02-3482-0999" style={{ color: "#BDBDBD" }}>02-3482-8835</a></span>
										<span className="">사업자등록번호: 114-82-09801</span>
									</p>
									<p className="mb-0">COPYRIGHT 2018 KARA. ALL RIGHTS RESERVED</p>
								</div>
								<div className="col-lg-5 col-md-12">
									<p className="mb-0 text-right">
										<span className="g-pr-10"><a href="https://www.instagram.com/animal_kara" target="_blank"><img src={instagram} className="g-width-25"/></a></span>
										<span className="g-pr-10"><a target="_blank" href="https://www.youtube.com/channel/UCUpmxwD2XMZB-7I2Dh8l-UQ"><img src={youtube} className="g-width-25"/></a></span>
										<span className="g-pr-10"><a target="_blank" href="https://www.facebook.com/kara.animal"><img src={facebook} className="g-width-25"/></a></span>
										<span className="g-pr-10"><a target="_blank" href="https://twitter.com/ekara_org"><img src={twitter} className="g-width-25"/></a></span>
										<span className="g-pr-10"><a target="_blank" href="http://blog.naver.com/animalkara"><img src={blog} className="g-width-25"/></a></span>
										<span className="g-pr-10"><a target="_blank" href="https://story.kakao.com/ch/kara"><img src={kakaostory} className="g-width-25"/></a></span>
										<span className=""><a target="_blank" href="http://happylog.naver.com/kara.do"><img src={happybean} className="g-width-25"/></a></span> 
									</p>
									<p className="text-right g-mt-10 mb-0">
										<span className="g-pr-10"><a href="#!" className="g-text-underline" style={{ color: "#BDBDBD" }}>이용약관</a></span>
										<span className="g-pr-10"><a href="/policy/privacy" className="g-text-underline" style={{ color: "#BDBDBD" }}>개인정보처리방침</a></span>
										<span className=""><a href="/policy/reject" className="g-text-underline" style={{ color: "#BDBDBD" }}>이메일수집거부</a></span>
									</p>
								</div>
							</div>	
						</div>

						<div className="g-hidden-md-up g-py-10">
							<div className="row flex-column flex-md-row justify-content-between align-items-center">
								<div className="col-auto g-px-15">
									<ul className="list-inline g-overflow-hidden mb-0">
										<li className="list-inline-item g-mx-4 g-mt-10"><a style={{ color: "#BDBDBD" }} href="#!">이용약관</a></li>
										<li className="list-inline-item g-mx-4 g-mt-10 g-color-gray-light-v3">|</li>
										<li className="list-inline-item g-mx-4 g-mt-10"><a style={{ color: "#BDBDBD" }} href="/policy/privacy">개인정보처리방침</a></li>
										<li className="list-inline-item g-mx-4 g-mt-10 g-color-gray-light-v3 g-hidden-xs-down">|</li>
										<li className="list-inline-item g-mx-4 g-mt-10"><a style={{ color: "#BDBDBD" }} href="/policy/reject">이메일수집거부</a></li>
									</ul>
								</div>
							</div>
							<div className="row flex-column  justify-content-between align-items-center">
								<div className="col-auto g-py-10">
									<ul className="list-inline g-overflow-hidden mb-0">
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="https://www.instagram.com/animal_kara"><img src={instagram} className="g-width-35 g-width-40--md" /></a></li>
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="https://www.youtube.com/channel/UCUpmxwD2XMZB-7I2Dh8l-UQ"><img src={youtube} className="g-width-35 g-width-40--md"/></a></li>
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="https://www.facebook.com/kara.animal"><img src={facebook} className="g-width-35 g-width-40--md"/></a></li>
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="https://twitter.com/ekara_org"><img src={twitter} className="g-width-35 g-width-40--md"/></a></li>
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="http://blog.naver.com/animalkara"><img src={blog} className="g-width-35 g-width-40--md"/></a></li>
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="https://story.kakao.com/ch/kara"><img src={kakaostory} className="g-width-35 g-width-40--md"/></a></li>
										<li className="list-inline-item g-ml-5 g-ml-15-md"><a target="_blank" href="http://happylog.naver.com/kara.do"><img src={happybean} className="g-width-35 g-width-40--md"/></a></li>
									</ul>
								</div>
							</div>

							<p className="mb-0 mt-2 font-weight-bold">(사)동물권행동 카라</p>
							<p className="mb-0">서울시 마포구 잔다리로 122 (우) 03998</p>
							<p className="mb-0">사업자등록번호: 114-82-09801</p>
							<p className="mb-3">대표: 전진경</p>

							<p className="mb-0">MAIL: <a href="mailto:info@ekara.org" style={{ color: "#BDBDBD" }}>info@ekara.org</a></p>
							<div className="row">
								<div className="col">
									<p className="mb-0">TEL: <a href="tel:02-3482-0999" style={{ color: "#BDBDBD" }}>02-3482-0999</a></p>
									<p className="mb-3">FAX : <a href="tel:02-3482-0999" style={{ color: "#BDBDBD" }}>02-3482-8835</a></p>
								</div>
								<div className="col">
									<p className="mb-0">COPYRIGHT 2018 KARA.</p>
									<p className="mb-3">ALL RIGHTS RESERVED</p>
								</div>
							</div>

						</div>
					</div>
                </footer>

                <aside className="aside g-hidden-1280-down">
                    <div className="aside-wrap text-center">
                        <div className="aside-toggler g-top-0" style={{ right: this.state.asideOffset }} >
                            <a href="https://page.stibee.com/subscriptions/166721" target="_blink"><img src={aside1} className="g-width-70" alt="" /></a>
		                </div>
                        <div className="aside-toggler g-top-80" style={{ right: this.state.asideOffset }} >
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeM-JrEjZ8wJNswKTofvnbeFhlXqwgCi3HgbwtSqp8J0xQBog/viewform" target="_blink"><img src={aside2} className="g-width-70" alt="" /></a>
		                </div>
                        <div className="aside-toggler g-top-160" style={{ right: this.state.asideOffset }}>
                            <a href="https://ekara.org/support/introduce" target="_blink"><img src={aside3} className="g-width-70" alt="" /></a>
                        </div>
                    </div>
                </aside>

                <ScrollToTop showUnder={160} duration={800} easing={"easeInOutQuint"}>
                    <span className="js-go-to u-go-to-v2" style={{ display: "inline-block" }}><i className="hs-icon hs-icon-arrow-top"></i></span>
                </ScrollToTop>


            </div>
        )
    }
}
                                                        
export default Footer;


// WEBPACK FOOTER //
// ./src/components/front/footer/footer.js